export class MfaRequiredError extends Error {
  name: string
  constructor(message = 'MFA required!') {
    super(message)
    this.name = 'MfaRequiredError'
  }
}

export class PasswordChangeRequestedError extends Error {
  name: string
  constructor(message = 'New password is required!') {
    super(message)
    this.name = 'PasswordChangeRequestedError'
  }
}
